import { IIdentityData } from '../../types/identities/IIdentityData';
import { IUpdateIdentityRequest } from '../../types/identities/IUpdateIdentityRequest';
import { BaseAPI } from '../BaseApi';
import { eAPITags } from '../eAPITags';

const IdentityAPI = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    updateIdentity: build.mutation<IIdentityData, IUpdateIdentityRequest>({
      query: ({ id, ...params }) => ({
        url: `/timber/api/internal/auth/identities/${id}`,
        method: 'PATCH',
        body: params,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: eAPITags.AdminUsersData, id },
        { type: eAPITags.AdminUsersData, id: 'LIST' },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useUpdateIdentityMutation } = IdentityAPI;
